import { ReactNode } from 'react'
import cx from 'classnames'

import { Button } from 'components/Button'

import { SetState } from 'types'
import Styles from './CreateInlineMenu.module.scss'
import { NewInlineOption } from './types'

interface InlineOptionProps {
  active: boolean
  icon: ReactNode
  inputValue: string
  isProcessing: boolean
  onCreate: () => void
  option: NewInlineOption | string
  optionName: string
  overrideWidth?: number | undefined
  setChosenOption: SetState<NewInlineOption | string>
  showText: boolean
  id?: string
}

export const InlineOption = ({
  onCreate,
  icon,
  isProcessing,
  overrideWidth,
  inputValue,
  option,
  active,
  setChosenOption,
  showText,
  optionName,
  id,
}: InlineOptionProps) => {
  return (
    <Button
      key={option}
      className={cx(Styles.button, { [Styles.activeButton]: active })}
      isDisabled={isProcessing}
      onPress={onCreate}
      size="md"
      id={id || option}
      variant="tertiary"
      data-testid="inline-option"
      data-option={option}
      onHoverStart={() => setChosenOption(option)}
    >
      <div className={Styles.buttonText}>
        <span className={Styles.optionIcon}>{icon}</span>
        <span className={Styles.createItemText}>{optionName}</span>
      </div>
      {active && (
        <span className={Styles.shortcutText}>
          {showText && (
            <span className={Styles.text} style={{ maxWidth: overrideWidth ? overrideWidth - 156 : undefined }}>
              {inputValue || 'Untitled'}
            </span>
          )}
          <span className={Styles.shortcut}>⏎</span>
        </span>
      )}
    </Button>
  )
}
